<template>
  <div>
    <!-- <b-modal
      ref="fnbadvertisementmodal"
      id="fnbadvertisementmodal"
      hide-header
      hide-footer
      size="lg"
      class="advertisement-modal"
    >
      <div class="text-right mb-3">
        <button
          class="btn btn-primary modal-btn-close"
          @click="closeFNBAdPopup"
        >
          &times;
        </button>
      </div>
      <div v-if="popups && popups.length > 0" class="text-center">
        <FnbAdSlider :Popups="popups" />
        <p v-if="popups[0].pop_text" v-html="popups[0].pop_text"></p>
      </div>
    </b-modal> -->
    <!-- LANDING SLIDER COMPONENT -->
    <LandingSlide />

    <!-- QUICK BOOKING COMPONENT -->
    <div class>
      <QucikBooking />
    </div>

    <!-- NOW SHOWING SECTION -->
    <section class="section-nowShowing">
      <div class="container">
        <header class="section-header mb-2">
          <div class="section-header-title">
            Now Showing
            <!-- {{
              getLoggedUser && getLoggedUser["user_name"]
                ? getLoggedUser["user_name"]
                : null
            }} -->
            <!-- <img
              src="@/assets/img/icons/home-icon-1.svg"
              alt
              class="home-gif-image"
            /> -->
          </div>
          <router-link
            v-if="!isLoadingMovies && movies.length"
            class="d-none d-md-block"
            to
            @click.native="onClickedViewAll"
            >View all >>></router-link
          >
          <router-link
            v-if="!isLoadingMovies && movies.length"
            class="d-md-none mobile-seeAll-btn"
            to
            @click.native="() => $router.push({ name: 'Movies' })"
            >See All</router-link
          >
        </header>
        <div class="row">
          <div class="col-12" v-if="isLoadingMovies">
            <component-content-loader />
          </div>

          <div
            :key="movieKey"
            class="col-6 col-sm-6 col-md-4 col-lg-3 col-xl-3 evenSpacing"
            v-for="(movie, movieKey) in movies"
          >
            <div
              v-if="!isLoadingMovies && movies.length"
              class="new-card-section position-relative"
            >
              <!-- SHOW ONLY ON MOBILE -->
              <div class="mobile-heart-btn d-md-none">
                <button
                  class="btn-like"
                  title="Like this movie"
                  @click="
                    getIsUserLogged === true
                      ? handleLikeMovie($event, movie.Film_strCode)
                      : onHandleOpenModal('signInModal')
                  "
                >
                  <b-icon
                    :icon="
                      movie.liked === 'Y' || movie.movie_liked
                        ? 'heart-fill'
                        : 'heart'
                    "
                    :variant="
                      movie.liked === 'Y' || movie.movie_liked
                        ? 'danger'
                        : 'secondary'
                    "
                  ></b-icon>
                </button>
              </div>
              <!-- SHOW ONLY ON MOBILE -->
              <div
                class="movie-listing-card"
                @click="
                  isMobile
                    ? $router.push({
                        name: 'Movie Details',
                        params: { movie_code: movie.Film_strCode }
                      })
                    : null
                "
              >
                <div
                  class="movie-card-img-box"
                  @click="
                    () =>
                      $router.push({
                        name: 'Movie Details',
                        params: { movie_code: movie.Film_strCode }
                      })
                  "
                >
                  <img
                    v-lazy="
                      movie && movie.image_path_1
                        ? IMAGE_URL + movie.image_path_1
                        : null
                    "
                    class="lazy-image img-fluid"
                    alt
                  />
                </div>

                <div class="movie-content">
                  <div>
                    <div :title="movie.Film_strTitle" class="movie-title">
                      <span>{{ movie.Film_strTitle }}</span>
                    </div>
                    <div class="d-none d-md-block">
                      <div class="movie-details-grid">
                        <div class="dot-list-1">
                          {{ movie.language_name }} <span></span>
                          {{ movie.genre_name }} <span></span>
                          {{ movie.Film_strCensor }} 
                        </div>
                        <button
                          class="btn-like"
                          title="Like this movie"
                          @click="
                            getIsUserLogged === true
                              ? handleLikeMovie($event, movie.Film_strCode)
                              : onHandleOpenModal('signInModal')
                          "
                        >
                          <!-- :icon="movieLiked ? 'heart-fill' : 'heart'"
                      :variant="movieLiked ? 'danger' : 'secondary'"-->
                          <b-icon
                            :icon="
                              movie.liked === 'Y' || movie.movie_liked
                                ? 'heart-fill'
                                : 'heart'
                            "
                            :variant="
                              movie.liked === 'Y' || movie.movie_liked
                                ? 'danger'
                                : 'secondary'
                            "
                          ></b-icon>
                          <span>{{ movie && movie.likes }}</span>
                          <!-- {{ movie.movie_liked }} -->
                        </button>
                      </div>
                    </div>

                    <!-- SHOW ONLY ON MOBILE -->
                    <div class="d-md-none">
                      <div class="dot-list-1">
                          {{ movie.language_name }} <span></span>
                          {{ movie.genre_name }} <span></span>
                          {{ movie.Film_strCensor }} 
                        </div>
                    </div>
                    <!-- SHOW ONLY ON MOBILE -->
                  </div>

                  <div class="d-none d-md-block mt-2">
                    <div class="row">
                      <div
                        class="
                          col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6
                          mb-2 mb-sm-0
                          pr-sm-1
                        "
                      >
                        <a
                          v-if="movie.youtube_url"
                          data-fancybox
                          :href="movie.youtube_url"
                          class="btn btn-outline-primary w-100 px-1"
                          >Play Trailer</a
                        >
                      </div>
                      <div
                        class="
                          col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6
                          pl-sm-1
                        "
                      >
                        <router-link
                          to
                          @click.native="
                            () =>
                              $router.push({
                                name: 'Movie Details',
                                params: { movie_code: movie.Film_strCode }
                              })
                          "
                          class="btn btn-primary w-100 px-1 font-weight-bold"
                          >Book Ticket</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <EmptyMovieState
            v-if="!isLoadingMovies && movies.length === 0"
            isClass="border-0"
            :emptyMessage="`No Movies Found`"
            :isNeedTopSpace="true"
          />
        </div>
      </div>
    </section>

    <!-- NO MOVIES SHOWING -->
    <!-- DESKTOP SITE -->
    <section v-if="false">
      <div class="container no-movie-found my-4 d-none d-md-block">
        <div class="row">
          <div class="col-md-3">
            <!-- <img
              src="@/assets/img/backgrounds/popcorn.svg"
              class="img-fluid"
              alt
            /> -->
          </div>
          <div class="col-md-6 align-self-center text-center">
            <!-- <h5 class="title">oh no.</h5>
            <p class="text">
              Because of the current pandemic, all screenings
              <br />have been called off. We’ll be back soon!
            </p> -->
            <div class="section-loader-new">
              <div class="lds-spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
          <div class="col-md-3 align-self-end text-right">
            <!-- <img
              src="@/assets/img/backgrounds/babycorn.svg"
              class="img-fluid"
              alt
            /> -->
          </div>
        </div>
      </div>

      <!-- MOBILE SITE -->
      <div class="container my-4 d-md-none">
        <div class="no-movie-found">
          <div class="row pt-5">
            <div class="col-3">
              <!-- <img
                src="@/assets/img/backgrounds/popcorn.svg"
                class="img-fluid"
                alt
              /> -->
            </div>
            <div class="col-6 align-self-center text-center align-self-end">
              <!-- <h5 class="title">oh no.</h5> -->
              <div class="section-loader-new">
                <div class="lds-spinner">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
            </div>
            <div class="col-3 align-self-end">
              <!-- <img
                src="@/assets/img/backgrounds/babycorn.svg"
                class="img-fluid"
                alt
              /> -->
            </div>
          </div>
        </div>
        <!-- 
        <p class="text">
          Because of the current pandemic, all screenings have been called off.
          We’ll be back soon!
        </p> -->
      </div>
    </section>

    <!-- COMING SOON COMPONENT -->
    <ComingSoon />

    <!-- PROMOTIONS AND OFFERS COMPONENT -->
    <!-- <PromotionsAndOffers /> -->

    <!-- DONWLOAD APP COMPONENTS -->
    <DownloadApp class="d-none d-md-block" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import LandingSlide from "@/components/partials/landingSlider";
import FnbAdSlider from "@/components/partials/FnbAdSlider";
import QucikBooking from "@/components/partials/quickBooking";
import ComingSoon from "@/components/partials/comingSoon.vue";
import PromotionsAndOffers from "@/components/partials/promotionsAndOffers";
import DownloadApp from "@/components/partials/downloadApp";
import MovieService from "@/apiServices/MovieService";
import { IMAGEURL } from "@/config";
import Vue from "vue";
import cookieType from "@/config/cookieType";
import MasterService from "@/apiServices/MasterService";

// setUserName
export default {
  data() {
    return {
      IMAGE_URL: IMAGEURL,
      movieLiked: false,
      movies: [],
      isLoadingMovies: false,
      showPopUp: true,
      popups: []
    };
  },
  components: {
    LandingSlide,
    QucikBooking,
    ComingSoon,
    PromotionsAndOffers,
    DownloadApp,
    FnbAdSlider
  },
  mounted() {
    this.getNowShowingMovies();

    let loader = Vue.$loading.show();
    setTimeout(() => {
      if (!Vue.cookie.get(cookieType.CITYID)) {
        this.$store.dispatch("onHandleOpenModal", "cityModalModal");
      }
      loader.hide();
    }, 2500);
  },
  computed: {
    isMobile() {
      return this.$store.state.AppSetting.isMobile;
    },
    ...mapGetters([
      "getIsUserLogged",
      "getLoggedUser",
      "getAllMovieList",
      "getModals"
    ])
  },
  methods: {
    ...mapActions(["onGetHomepageMovies", "onHandleOpenModal"]),
    async getNowShowingMovies(params = {}) {
      // let loader = Vue.$loading.show();
      this.isLoadingMovies = true;
      this.movies = [];
      const user_id = this.getIsUserLogged ? this.getLoggedUser.user_id : null;
      MovieService.NowShowingMovies({ user_id })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.movies = data.data;
          }
        })
        .finally(() => {
          setTimeout(() => (this.isLoadingMovies = false), 500);
          // loader.hide();
        });
    },
    async handleLikeMovie(e, movie_code) {
      if (movie_code) {
        const response = await MovieService.LikeMovie({ movie_code });
        const { data } = response;
        if (data && data.status) {
          if (data.data === "unliked") {
            const index = this.movies.findIndex(
              movie => movie.Film_strCode === movie_code
            );
            if (index > -1) {
              this.movies[index].movie_liked = false;
              this.movies[index].likes = this.movies[index].likes - 1;
              this.movies[index].liked = "N";
              this.$forceUpdate();
            }
          } else {
            const index = this.movies.findIndex(
              movie => movie.Film_strCode === movie_code
            );
            if (index > -1) {
              this.movies[index].movie_liked = true;
              this.movies[index].likes = this.movies[index].likes + 1;
              this.$forceUpdate();
            }
          }
        }
      }
    },
    async getPopups() {
      try {
        if (this.getModals.fnbAdModalShown) {
          return;
        }
        this.$nextTick(async () => {
          const response = await MasterService.GetPopups();
          if (response.data.status) {
            this.popups = response.data.data;
            if (this.popups.length > 0) {
              this.$refs["fnbadvertisementmodal"].show();
            }
          }
          this.$store.commit("ON_SET_FNB_MODAL_SHOWN", true);
        });
      } catch (err) {
        console.log("Error in getting popups ", err);
      }
    },
    closeFNBAdPopup() {
      this.$refs["fnbadvertisementmodal"].hide();
    },
    onClickedViewAll() {
      sessionStorage.setItem('movie_path','now_showing');
      this.$router.push({ name: 'Movies' });
    }
  },
  beforeMount() {

if (location.protocol !== 'https:') {
    // location.replace(`https:${location.href.substring(location.protocol.length)}`);
}

    this.getPopups();
  }
};
</script>
<style scoped>
.advertisement-modal .modal-content {
  color: #fff;
  background-color: transparent !important;
  border: 1px solid transparent;
}
.advertisement-modal .modal-backdrop.show {
  opacity: 0.75;
}
.advertisement-modal .btn-close {
  position: fixed;
  top: 0px;
  right: 0px;
  line-height: 1;
  font-size: 60px;
  color: #fff;
  cursor: pointer;
  border: none;
  line-height: 1;
  z-index: 99;
  background-color: transparent;
}
/* .lazy-image {
  width: 264px;
  height: 319px;
} */
</style>


// WEBPACK FOOTER //
// src/components/pages/homePage.vue